import React from 'react';

import ParameterMap from './ParameterMap';
import { GatsbyPageProps, PageContext } from './types';

export interface AirtableContextData extends PageContext {
  generalParameters: ParameterMap
  pageParameters: ParameterMap
}

export const AirtableContext = React.createContext<AirtableContextData | null>(null);

export const AirtableDataConsumer = AirtableContext.Consumer;

interface Props {
  gatsbyContext: GatsbyPageProps['pageContext']
}

export class AirtableDataProvider extends React.Component<Props> {

  render()
  {
    const { airtable, slug } = this.props.gatsbyContext;

    const currentPage = airtable.pages.find(p => p.meta.Slug === slug);

    if (!currentPage || !slug) {
      throw new Error(`page with slug ${slug} was not found in airtable data`);
    }

    const generalParameters = new ParameterMap(airtable.general);
    const pageParameters = new ParameterMap(currentPage.parameters);

    const contextData: AirtableContextData = {
      ...this.props.gatsbyContext,
      generalParameters,
      pageParameters
    };

    return (
      <AirtableContext.Provider value={ contextData }>
        { this.props.children || null }
      </AirtableContext.Provider>
    );

    }

}